import { defineMessages } from "react-intl";

export const messages = defineMessages({
	title: {
		id: "form.password_reset",
		defaultMessage: "Jelszó helyreállítása"
	},
	help: {
		id: "form.password_reset.help",
		defaultMessage: "Kérjük adja meg az új jelszavát."
	},
	submit: {
		id: "form.password_reset.submit",
		defaultMessage: "Jelszó helyreállítása"
	}
});

export const labels = defineMessages({
	password: {
		id: "form.password_reset.password",
		defaultMessage: "Jelszó"
	},
	passwordAgain: {
		id: "form.password_reset.password_again",
		defaultMessage: "Jelszó újra"
	}
});

export const errors = defineMessages({
	passwordRequired: {
		id: "form.password_reset.password.error.required",
		defaultMessage: "A jelszó kötelező."
	},
	passwordMinLength: {
		id: "form.password_reset.password.error.min_length",
		defaultMessage: "A jelszó minimalális hossza {minLength}."
	},
	passwordConst: {
		id: "form.password_reset.password.error.const",
		defaultMessage: "A jelszavak nem egyeznek meg."
	}
});
